import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import ButtonPrimary from "./ButtonPrimary";
import ConditionToggle from "./ConditionToggle";
import { DARK } from "../core/constants";
import { FILTER_BAR_INDEX } from "../core/constants";
import React from "react";
import SortBy from "./SortBy";
import { useAppContext } from "./AppContext";
import { REPAIRED_FILTER_TYPE } from "../core/constants";
import { useListingsContext } from "./ListingsContext";
import {
  getAvailableFiltersOfType,
  getConditionFiltersInOrder,
} from "../core/utils";
import RepairedFilter from "./RepairedFilter";

function FilterAndSort() {
  const { setFilterMenuOpen } = useAppContext();
  const { availableFilters, activeFilters } = useListingsContext();

  const [brandNew, asNew, preLoved] =
    getConditionFiltersInOrder(availableFilters);

  const repairedFilter = getAvailableFiltersOfType(
    availableFilters,
    REPAIRED_FILTER_TYPE
  );

  return (
    <BoxWithGutter
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      height={60}
      bg="white"
      position="sticky"
      top={60}
      zIndex={FILTER_BAR_INDEX}
    >
      <ButtonPrimary
        theme={DARK}
        onClick={() => {
          setFilterMenuOpen(true);
        }}
      >
        Filter
      </ButtonPrimary>
      <Box display={[null, "flex", null, null]} alignItems="center">
        {activeFilters && (
          <Box
            display={["none", null, "flex", null]}
            pl={[null, 10, null, null]}
            ml={[null, 20, null, null]}
          >
            {typeof brandNew !== "undefined" && (
              <Box key={brandNew.label} ml={15}>
                <ConditionToggle option={brandNew} showTooltip />
              </Box>
            )}
            {typeof asNew !== "undefined" && (
              <Box key={asNew.label} ml={15}>
                <ConditionToggle option={asNew} showTooltip />
              </Box>
            )}
            {typeof preLoved !== "undefined" && (
              <Box key={preLoved.label} ml={15}>
                <ConditionToggle option={preLoved} showTooltip />
              </Box>
            )}
            {typeof repairedFilter !== "undefined" && (
              <Box ml={15}>
                <RepairedFilter showTooltip />
              </Box>
            )}
          </Box>
        )}

        <Box
          pl={[null, 20, null, null]}
          ml={[null, 20, null, null]}
          pt={[10, 0, null, null]}
          borderLeftWidth={[null, "1px", null, null]}
          borderLeftStyle={[null, "solid", null, null]}
          borderLeftColor={[null, "lightGrey", null, null]}
          height={16}
          display="flex"
          alignItems="center"
        >
          <SortBy />
        </Box>
      </Box>
    </BoxWithGutter>
  );
}

export default FilterAndSort;
